export const nav = {
  dashboard: 'Vezérlőpult',
  customers: 'Ügyfelek',
  customerRelationshipLogs: 'Ügyfélkapcsolati napló',
  products: 'Termékek',
  offers: 'Árajánlatok',
  deals: 'Ügyletek',
  contracts: 'Szerződések',
  reports: 'Jelentések',
  settings: 'Beállítások',
  profile: 'Profil',
  system_admin: 'Rendszergazda',
  templates: 'Sablonok',
  documentStorage: 'Dokumentumtár',
  workPagesTemplates: 'Kitöltendő munkalap',
  filledWorkpage: 'Kitöltött munkalap',
  organization: 'Szervezet',
  selectOrganization: 'Válassz szervezetet',
  // Csoportok
  groups: {
    crm: 'CRM & Értékesítés',
    products: 'Termékek & Dokumentumok',
    documents: 'Dokumentumok',
    energia: 'Villamos energia'
  },
  // Energia Management menüpontok
  energia_dashboard: 'Energia Dashboard',
  energia_pods: 'Energia POD-ok',
  consumption_locations: 'Fogyasztási Helyek',
  energia_contracts: 'Energia Szerződések',
  energia_products: 'Energia Termékek',
  bulk_invoice_manager: 'Tömeges Számlázás',
  energia_billing: 'Energia Számlázás',
  energia_analytics: 'Energia Analitika',
  energia_monitoring: 'Energia Monitoring',
  energia_utilmd: 'Energia UTILMD',
  mscons_readings: 'MSCONS Fogyasztások'
}